import { pick } from 'lodash-es'

const M_BETSLIPS = 'M_BETSLIPS'

const CACHE_SELECTIONS_KEYS = [
  'id',
  'status',
  'sport',
  'sportId',
  'category',
  'categoryId',
  'tournament',
  'tournamentId',
  'eventId',
  'homeTeam',
  'awayTeam',
  'marketInfo',
  'outcomeInfo',
  'betStatus',
  'popularCombos',
  'betBuilderSelections'
]

// const EXCLUDE_SELECTIONS_KEYS = [
//   'categoryIcon',
//   'commentCount',
//   'hasLiveWidget',
//   'hasVoucher',
//   'homeTeamId',
//   'awayTeamId',
//   'bookingStatus',
//   'hasLive',
//   'hasLiveCoverage',
//   'isTopTeam',
//   'marketsCount',
//   'playedTime',
//   'roundNumber',
//   'roundType',
//   'scoreInCurrentSection',
//   'scoreOfSection',
//   'scoreOfWholeMatch',
//   'sectionRemainTime',
//   'server',
//   'startTime',
//   'statusDescription',
//   'stoppagePlayedTime',
//   'stoppageTime',
//   'totalPlayedTime'
// ]

export const filterSelectionKeys = (selections) => {
  return selections.map((x) => {
    if ('betBuilderSelections' in x) {
      x.betBuilderSelections = filterSelectionKeys(x.betBuilderSelections)
    }
    return pick(x, CACHE_SELECTIONS_KEYS)
  })
}

export const getLocalSelections = () => {
  try {
    const data = localStorage.getItem(M_BETSLIPS)
    if (data) {
      const list = JSON.parse(data)
      if (Array.isArray(list) && list.every((x) => typeof x === 'object' && x !== null && !!x.id && x.marketInfo && x.marketInfo.product)) {
        return filterSelectionKeys(list)
      } else {
        localStorage.removeItem(M_BETSLIPS)
        return []
      }
    }
    return []
  } catch (error) {
    localStorage.removeItem(M_BETSLIPS)
    console.error('error local betslip json', error)
    return []
  }
}

export const getSelectionId = (eventId = '', marketId = '', outcomeId = '', specifiers = '') => {
  let id = `${eventId}_${marketId}_${outcomeId}`
  if (specifiers) {
    id += `_${specifiers}`
  }
  return id
}

export const formatSelection = (outcome, market, event) => {
  const marketInfo = { ...market }
  const eventInfo = { ...event }
  const outcomeInfo = { ...outcome }
  if (!('isSuspended' in outcomeInfo)) {
    outcomeInfo.isSuspended = false
  }
  if (!('isUnavailable' in outcomeInfo)) {
    outcomeInfo.isUnavailable = false
  }
  delete marketInfo.outcomes
  delete eventInfo.markets
  const id = getSelectionId(event.eventId, market.id, outcome.id, market.specifiers)
  return {
    id,
    outcomeInfo,
    marketInfo,
    ...eventInfo
  }
}

export const saveLocalSelections = (list) => {
  const cacheList = filterSelectionKeys(list)
  localStorage.setItem(M_BETSLIPS, JSON.stringify(cacheList))
}

export const findSelectionIndex = (list = [], outcomeId, marketId, eventId, specifiers) => {
  return list.findIndex((x) => x.eventId === eventId && `${x.marketInfo.id}` === `${marketId}` && `${x.outcomeInfo.id}` === `${outcomeId}` && (!specifiers || specifiers === x.marketInfo.specifiers))
}
